module.exports = function () {
    return new Worker(__webpack_public_path__ + "c1df83908983b6d40319.worker.js");
};
